module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subheading py-0 grey lighten-4"
  }, [_vm._v("\n    Assign a program\n    "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs6": "",
      "sm5": ""
    }
  }, [_c('v-text-field', {
    staticClass: "ma-2",
    attrs: {
      "outline": "",
      "outlined": "",
      "loading": _vm.requests.templates.loading,
      "hint": "Press enter to search or click the search button",
      "label": "Search templates",
      "append-icon": "search"
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getTemplates.apply(null, arguments)
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        $event.stopPropagation();
        _vm.search = ""
      },
      "keyup": _vm.debounceTemplates,
      "click:append": _vm.getTemplates
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_vm._l((_vm.templates), function(template) {
    return [_c('v-list-tile', {
      key: template.id,
      class: _vm.selectedClass(template, _vm.selectedTemplate),
      on: {
        "click": function($event) {
          _vm.selectedTemplate = template
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(template.name))]), _vm._v(" "), _c('V-list-tile-sub-title', [_vm._v("\n                By " + _vm._s(template.author || 'Physitrack') + "\n              ")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-icon', [_vm._v("chevron_right")])], 1)], 1), _vm._v(" "), _c('v-divider', {
      key: ("div=" + (template.id))
    })]
  })], 2)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm7": ""
    }
  }, [(_vm.hasActiveProgram) ? _c('v-alert', {
    attrs: {
      "value": true,
      "type": "warning",
      "dismissible": "",
      "text": "",
      "dense": "",
      "outline": "",
      "tile": ""
    }
  }, [_c('strong', [_vm._v("Warning")]), _vm._v("\n        This client has an active program. Assigning a new program will terminate the current program\n      ")]) : _vm._e(), _vm._v(" "), (_vm.selectedTemplate && _vm.selectedTemplate.id) ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.selectedTemplate.name))]), _vm._v(" "), _c('V-list-tile-sub-title', [_vm._v("\n                " + _vm._s(_vm.selectedTemplate.description) + "\n              ")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "loading": _vm.requests.assign.loading,
      "color": "primary",
      "small": ""
    },
    on: {
      "click": _vm.assign
    }
  }, [_vm._v("Assign")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "width": "290"
    },
    model: {
      value: (_vm.showdatepicker),
      callback: function($$v) {
        _vm.showdatepicker = $$v
      },
      expression: "showdatepicker"
    }
  }, [_c('v-card', [_c('v-date-picker', {
    attrs: {
      "min": _vm.today,
      "full-width": ""
    },
    model: {
      value: (_vm.program.start_date),
      callback: function($$v) {
        _vm.$set(_vm.program, "start_date", $$v)
      },
      expression: "program.start_date"
    }
  })], 1)], 1), _vm._v(" "), _c('v-text-field', {
    staticClass: "ma-2",
    attrs: {
      "readonly": "",
      "label": "Start date"
    },
    on: {
      "click": function($event) {
        _vm.showdatepicker = true
      }
    },
    model: {
      value: (_vm.program.start_date),
      callback: function($$v) {
        _vm.$set(_vm.program, "start_date", $$v)
      },
      expression: "program.start_date"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "ma-2",
    attrs: {
      "label": "Duration",
      "type": "number",
      "suffix": "weeks"
    },
    model: {
      value: (_vm.program.num_weeks),
      callback: function($$v) {
        _vm.$set(_vm.program, "num_weeks", $$v)
      },
      expression: "program.num_weeks"
    }
  })], 1)], 1), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "label": "Track adherence"
    },
    model: {
      value: (_vm.program.track_adherence),
      callback: function($$v) {
        _vm.$set(_vm.program, "track_adherence", $$v)
      },
      expression: "program.track_adherence"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "label": "Track pain levels"
    },
    model: {
      value: (_vm.program.track_pain_levels),
      callback: function($$v) {
        _vm.$set(_vm.program, "track_pain_levels", $$v)
      },
      expression: "program.track_pain_levels"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "label": "Don't send program to user"
    },
    model: {
      value: (_vm.program.skip_access_code),
      callback: function($$v) {
        _vm.$set(_vm.program, "skip_access_code", $$v)
      },
      expression: "program.skip_access_code"
    }
  })], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": "",
      "sub-header": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("\n            Exercises\n          ")]), _vm._v(" "), _vm._l((_vm.selectedTemplate.exercises), function(exercise) {
    return _c('v-list-tile', {
      key: exercise.id
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(exercise.name)
      }
    })], 1)], 1)
  })], 2)], 1) : _c('v-card', {
    staticClass: "mt-4",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subheading"
  }, [_c('v-icon', {
    staticClass: "pr-3"
  }, [_vm._v("arrow_back")]), _vm._v(" Choose an exercise template\n        ")], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cab66760","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Integrations/Physitrack/AssignProgram.vue
// module id = 1522
// module chunks = 9